import React from 'react';
import { BadgeWrapper, Button } from '@carnica/ui-kit';
import { IconBasketFilled } from '@carnica/graphics';
import { HeaderThemeView } from "../../store/slices/layout";
export var Cart = function Cart(_ref) {
  var quantity = _ref.quantity,
    headerTheme = _ref.headerTheme,
    onClick = _ref.onClick;
  return /*#__PURE__*/React.createElement(BadgeWrapper, {
    content: String(quantity),
    "data-t-id": "components-Cart"
  }, /*#__PURE__*/React.createElement(Button, {
    iconLeft: IconBasketFilled,
    onClick: onClick,
    onlyIcon: true,
    size: "m",
    view: HeaderThemeView[headerTheme],
    "data-t-id": "components-Cart"
  }));
};